import { Component, OnInit ,OnDestroy} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from '../common.service';
import { Router } from '@angular/router';
import { FormBuilder, Validators , FormGroup} from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfirmPasswordValidator} from 'src/validators/passwordmatch';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationService } from '../notification.service';
import { Subject, takeUntil } from 'rxjs';
import {AdminRightServiceService} from "../shared/admin.rights.service";
@Component({
  selector: 'app-create-customer',
  templateUrl: './create-customer.component.html',
  styleUrls: ['./create-customer.component.scss']
})
export class CreateCustomerComponent implements OnInit,OnDestroy {
  Submitted: boolean=false;
  creatCustomer: FormGroup 
  private unsubscribe=new Subject <void>();
  constructor(public dialog: MatDialog,private snack:MatSnackBar,public adminRules:AdminRightServiceService,private spinner:NgxSpinnerService,private router: Router,private notification:NotificationService,private fb: FormBuilder,private service:CommonService, private dialogRef: MatDialogRef<CreateCustomerComponent>) 
   { }
 
  ngOnInit() {
    this.creatCustomer = this.fb.group(
      {
          name: ['', [Validators.required ,
            Validators.minLength(1),
            Validators.maxLength(150),
            Validators.pattern(/^[A-Za-z_. ]+$/)]],
          email: ['', [Validators.required, Validators.email
          , Validators.pattern(/^(?!.*\.\.)[A-Za-z0-9][A-Za-z0-9._%+-]*@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/)]],
          phoneNo :['', [Validators.required,
            Validators.pattern(/^\d{10}$/)]],

        //   Password: ['',  [
        //     Validators.required,
        //     Validators.pattern( /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/),
        //     Validators.minLength(8),
        //    ]],
        //    CONFIRMPassword:['',[Validators.required,
        //   Validators.minLength]]
        // },
        // {
        //   validator: ConfirmPasswordValidator("Password", "CONFIRMPassword")
        // }
          }
    )
    }

  get f() {
    return this.creatCustomer?.controls;
  }
  createcustomer(valid){
    this.Submitted = true
    this.creatCustomer?.markAllAsTouched()
    if(valid){
      this.spinner.show()
      let nameControl = this.creatCustomer.controls['name'];
      let trimmedName = nameControl.value?.replace(/\s+/g, ' ').trim();

      if (trimmedName !== nameControl.value) {
          nameControl.setValue(trimmedName, { emitEvent: false });
      }
      let req ={
          "name" : this.creatCustomer.controls['name'].value,
          "email" : this.creatCustomer.controls['email'].value,
          "phoneNo"  : this.creatCustomer.controls['phoneNo'].value.toString(),
        }

      this.service. postdata(req)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data : any)=> {
       this.spinner.hide()
        if(data.statusCode==200){
          // this.snack.open("Created successfully",'',{
          //   duration:3000,
          //  verticalPosition:'top',
          //  horizontalPosition: 'end'
          // })
          this.notification.showSuccess("Consumer Created successfully !",'')
          this.dialogRef.close();
          this.router.navigate(['/main/customer'])
        }    
        },
        (error:HttpErrorResponse)=>{
          this.spinner.hide()
          if(error.error.statusCode === 400){
            // this.snack.open(error.error.message,'',{
            //   duration:3000,
            //  verticalPosition:'top',
            //  horizontalPosition: 'end',
      
            // })
            this.notification.showWarning(error.error.message,'')
            this.creatCustomer?.reset();
          }
          else{
        this.snack.open("Something went wrong",'',{
          duration:3000,
         verticalPosition:'top',
         horizontalPosition: 'end',
  
        })
      }
    }
    )
  }
}
reset(){
  this.creatCustomer?.reset();
}
closeDialog() {
  this.dialogRef.close();
}
Space(event: any) {
  if (event.target.selectionStart == 0 && event.code === "Space") {
    event.preventDefault();
  }
}
ngOnDestroy(): void {
  this.unsubscribe.next();
  this.unsubscribe.complete()
}
}

